import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { IPatientInfo } from "../../../../../@types/Patient";
import { ISurveyAnswer } from "../../../../../@types/Surveys";
import { AnswerSurvey } from "../../../../Surveys/Answer Survey/Components/Survey";
import {
  AnswerSurveyContainer,
  BuilderLayoutContainer,
  CancelButton,
  Header,
  Title,
  TitleContainer,
} from "./AnswerClinicianFormModal.styles";

type AnswerClinicianFormModalProps = {
  patient: IPatientInfo;
  surveyAnswersToEdit?: ISurveyAnswer[];
  handleFormCancel: () => void;
  userSurveyId?: string;
  surveyAnswerId?: string;
  surveyId?: string;
  handleFormSubmit: (responseStatus?: number) => void;
};

export function AnswerClinicianFormModal({
  patient,
  userSurveyId,
  surveyAnswerId,
  surveyAnswersToEdit,
  surveyId,
  handleFormCancel,
  handleFormSubmit,
}: AnswerClinicianFormModalProps) {
  const { t } = useTranslation();

  return (
    <BuilderLayoutContainer>
      <Header>
        <TitleContainer>
          <Title>{patient.user?.name}</Title>
          <span>•</span>
          <Title>
            {patient.birthDate &&
              dayjs().diff(dayjs(patient.birthDate), "year")}
          </Title>
          <Title>{patient.gender && patient.gender.toUpperCase()}</Title>
        </TitleContainer>

        <CancelButton onClick={handleFormCancel}>
          {t("common_cancel")}
        </CancelButton>
      </Header>
      <AnswerSurveyContainer>
        <AnswerSurvey
          clinicianUserSurveyId={userSurveyId}
          surveyAnswerId={surveyAnswerId}
          patientUserId={patient?.user.id}
          onClinicianFormSubmit={handleFormSubmit}
          surveyId={surveyId}
          surveyAnswersToEdit={surveyAnswersToEdit}
        />
      </AnswerSurveyContainer>
    </BuilderLayoutContainer>
  );
}
